import { KeyValuePair } from "./types";

export const extractQueryParameters = (url: string): Array<KeyValuePair> | null => {

	const querySeparator = "?";
	const paramSeparator = "&";
	const keyValueSeparator = "=";

	if (url === null || url === undefined)
		return null;


	if (url.indexOf(querySeparator) === -1)
		return null;

	const queryParams = url.split(querySeparator).pop();

	if (queryParams === null || queryParams === undefined)
		return null;

	const hasQueryParameters = queryParams.indexOf(paramSeparator) !== -1;

	const paramList = hasQueryParameters ? queryParams.split(paramSeparator) : [queryParams];

	const KeyValuePair = paramList.filter( param => {
		if (!param || param.indexOf(keyValueSeparator) === -1)
			return false;
		return true;
	}).map( param => {
		const [key, value] = param.split(keyValueSeparator);
		return { key, value };
	});
	return KeyValuePair;
}

// toctoc.com -> return ".toctoc.com" / www.toctoc.com -> return ".toctoc.com"
export const extractLastPartUrl = (urlBase: string) => {
	if (urlBase === "") return "";
	try {
		const url = new URL(urlBase);
		if (url.hostname === 'localhost') return url.hostname;
		const urlSeparate = url.hostname.split(".");
		if (urlSeparate.length > 2) {
			const lastTwoPartsUrl = urlSeparate.slice(-2);
			const urlExtract = `.${lastTwoPartsUrl.shift()}.${lastTwoPartsUrl.pop()}`
			return urlExtract;
		}
	} catch {
		return "";
	}
}

export const tryToGetUrlHost = (url:string) => {
	try {
		if (url === undefined || url === null || url.trim() === "")
			return null;
		const urlObject = new URL(url);
		return `${urlObject.protocol}${urlObject.hostname}`
	} catch (ex) {
		return null;
	}
}

/**
 * Allow to customize the last segment of the url, 
 * from `https://d1cfu8v5n1wsm.cloudfront.net/toctoc/fotos/20200121/1404811/2020012112451549175.jpg`
 * to `https://d1cfu8v5n1wsm.cloudfront.net/toctoc/fotos/20200121/1404811/n_wm_2020012112451549175.jpg`
 * @param url 
 * @param suffix 
 * @returns 
 */
export const addImgSuffix = (url:string, suffix = "n_wm_") : string => {
	const lastDotIndex = url.lastIndexOf(".");
	const lastSlashIndex = url.lastIndexOf("/");
	if (lastDotIndex === -1 || lastSlashIndex === -1 || lastDotIndex < lastSlashIndex)
		return url;
	// Include the slash
	const preSuffixPart = url.substring(0, lastSlashIndex + 1)
	// From the slash (exclude)
	const postSuffixPart = url.substring(lastSlashIndex+1);
	const newUrl = `${preSuffixPart}${suffix}${postSuffixPart}`;
	
	return newUrl;
}

const rasterExtAtPathEnd = /\.(jpe?g|png|gif)$/i

/**
 * Replaces only the file extension with `.webp` when the path ends in a common raster format.
 * Preserves query string and hash. No-op if already `.webp` or extension is not replaced.
 */
export const preferWebpExtension = (url: string): string => {
	if (url === null || url === undefined || url === "")
		return url
	const q = url.indexOf("?")
	const h = url.indexOf("#")
	let cut = url.length
	if (q >= 0)
		cut = Math.min(cut, q)
	if (h >= 0)
		cut = Math.min(cut, h)
	const head = url.slice(0, cut)
	const tail = url.slice(cut)
	if (/\.webp$/i.test(head))
		return url
	if (!rasterExtAtPathEnd.test(head))
		return url
	const nextHead = head.replace(rasterExtAtPathEnd, ".webp")
	return `${nextHead}${tail}`
}

/** Safe on SSR / non-browser: returns false. */
export const browserSupportsWebp = (): boolean => {
	if (typeof document === "undefined")
		return false
	try {
		const c = document.createElement("canvas")
		c.width = 1
		c.height = 1
		return c.toDataURL("image/webp").indexOf("data:image/webp") === 0
	} catch {
		return false
	}
}

export const normalizeString = (str: string) => {
	return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\./g, '').replace(/\s+/g, "-").toLowerCase();
}

export const getUrlParameters = () => {	
	const currentLocation = typeof window !== "undefined" ? window.location : undefined;
	if (currentLocation === undefined)
		return {};
	const searchParams = new URLSearchParams(currentLocation.search);
	if (searchParams.toString() === "")
		return {};
	
	const urlObject: { [key: string]: string | string[] } = {};
	
	// Handle duplicate parameters (like estado=1&estado=2)
	for (const [key, value] of searchParams) {
		if (urlObject[key]) {
			// If the key already exists, convert to array or append to existing array
			if (Array.isArray(urlObject[key])) {
				(urlObject[key] as string[]).push(value);
			} else {
				urlObject[key] = [urlObject[key] as string, value];
			}
		} else {
			urlObject[key] = value;
		}
	}

	return urlObject
}